<template>
  <div class="receive-overlay" @click.self="$emit('close')">
    <div class="receive-modal">
      <div class="receive-header">
        <span>📥 Receive {{ chainLabel }}</span>
        <button class="btn btn-sm btn-outline-secondary" @click="$emit('close')">✕</button>
      </div>
      <div class="receive-body">
        <canvas ref="qrCanvas" class="qr-canvas"></canvas>
        <p class="addr-text text-break small mt-3">{{ address }}</p>
        <button class="btn btn-sm btn-outline-secondary mt-1" @click="copy">📋 Copy Address</button>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';

const CHAIN_LABELS = {
  tron: 'TRX', solana: 'SOL', ethereum: 'ETH',
  bsc: 'BNB', polygon: 'MATIC', bitcoin: 'BTC',
};

export default {
  name: 'ReceiveModal',
  props: {
    address: { type: String, required: true },
    chain:   { type: String, default: '' },
  },
  computed: {
    chainLabel() { return CHAIN_LABELS[this.chain] || this.chain.toUpperCase(); },
  },
  mounted() {
    this.$nextTick(() => this.renderQR());
  },
  methods: {
    renderQR() {
      QRCode.toCanvas(this.$refs.qrCanvas, this.address, {
        width: 200, margin: 2, color: { dark: '#000000', light: '#ffffff' },
      }).catch(e => console.error('QR error:', e));
    },
    copy() {
      navigator.clipboard.writeText(this.address).then(() => {
        if (this.$notice) this.$notice.success({ title: 'Copied', description: 'Address copied to clipboard.', duration: 2 });
      });
    },
  },
};
</script>

<style scoped>
.receive-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.72);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: overlayIn 0.18s ease;
}
@keyframes overlayIn { from { opacity: 0; } to { opacity: 1; } }

.receive-modal {
  background: var(--surface, #111520);
  border: 1px solid var(--border-2, #2e3650);
  border-radius: 18px;
  padding: 0;
  min-width: 300px;
  max-width: 360px;
  box-shadow: 0 24px 80px rgba(0,0,0,0.7);
  animation: modalIn 0.22s cubic-bezier(0.16,1,0.3,1);
}
@keyframes modalIn {
  from { opacity: 0; transform: scale(0.92) translateY(16px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.receive-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border, #242a3a);
  font-weight: 700;
  font-size: 0.88rem;
  color: var(--text, #c8cfe8);
  letter-spacing: 0.02em;
}

.receive-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 24px 28px;
}

.qr-canvas {
  border-radius: 12px;
  border: 4px solid var(--surface-2, #171b28);
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
}

.addr-text {
  max-width: 260px;
  text-align: center;
  color: var(--text-2, #8892b0);
  word-break: break-all;
  font-size: 0.76rem !important;
  font-family: monospace;
  line-height: 1.5;
  background: var(--surface-2, #171b28);
  border: 1px solid var(--border, #242a3a);
  border-radius: 8px;
  padding: 8px 12px;
}
</style>
